var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLivesvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 20,
    viewBox: "0 0 40 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "live_1_",
    "data-name": "live (1)",
    transform: "translate(-4 -14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_555",
    "data-name": "Rectangle 555",
    width: 40,
    height: 20,
    rx: 2.97,
    transform: "translate(4 14)",
    fill: "#ea2525"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_72730",
    "data-name": "Group 72730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_78578",
    "data-name": "Path 78578",
    d: "M16,28H12V19a1,1,0,0,0-2,0V29a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78579",
    "data-name": "Path 78579",
    d: "M20,18a1,1,0,0,0-1,1V29a1,1,0,0,0,2,0V19A1,1,0,0,0,20,18Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78580",
    "data-name": "Path 78580",
    d: "M30.287,18.042a1,1,0,0,0-1.245.671L27,25.52l-2.042-6.807a1,1,0,0,0-1.916.574l3,10a1,1,0,0,0,1.916,0l3-10A1,1,0,0,0,30.287,18.042Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78581",
    "data-name": "Path 78581",
    d: "M39,28H35V25h3a1,1,0,0,0,0-2H35V20h4a1,1,0,0,0,0-2H34a1,1,0,0,0-1,1V29a1,1,0,0,0,1,1h5a1,1,0,0,0,0-2Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivesvg);
export default __webpack_public_path__ + "static/media/livesvg.142e3275cf4e9257e8ad3ad20b14851d.svg";
export { ForwardRef as ReactComponent };